import { useMemo, useState, useEffect, useRef } from 'react';
import { Card, Col, Row, Button } from 'react-bootstrap';
import Alert from 'react-bootstrap/Alert';
import PageTitle from '../../../includes/PageTitle';
import Tables from '../../../components/Tables/Tables';
import Modals from '../../../components/Modals/Modals';
import Loader from '../../../components/Loader/Loader';
import SelectFild from '../../../components/SelectFild/SelectFild';
import { useFormik } from 'formik';
import { ToastContainer, toast } from 'react-toastify';
import { getProjectCategoryMap, postCommonMaster, postProduct, postProductSave, getProductDetails, deleteProduct } from '../../../apiservices/ApiServices';

import { FaFilePdf, FaTrashAlt } from "react-icons/fa";
import pdfUrl from '../../../assets/pdf/Gratuity.pdf'

const Products = () => {
    const [show, setShow] = useState(false);
    const [isLoading, setLoading] = useState(true);
    const [isLoadings, setLoadings] = useState(false);
    const [addModal, setAddModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [data, setData] = useState([]);
    const [commonMaster, setCommonMaster] = useState([]);
    const [uploadModal, setUploadModal] = useState(false);
    const [projectCategory, setProjectCategory] = useState([]);
    const [productCategory, setProductCategory] = useState([]);
    const [productSubCategory, setProductSubCategory] = useState([]);
    const [activityTemplates, setActivityTemplates] = useState([]);
    const fileInputRef = useRef(null);
    const [files, setFiles] = useState([]);

    const [selectedClientCentricObjects, setSelectedClientCentricObjects] = useState([]);
    const [selectedBillingCentricObjects, setSelectedBillingCentricObjects] = useState([]);


    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        handleFiles(droppedFiles);
    };

    const handleFileSelect = (e) => {
        const selectedFiles = Array.from(e.target.files);
        handleFiles(selectedFiles);
    };

    const handleFiles = (fileList) => {
        // Filter for specific file types if needed
        const validFiles = fileList.filter(file =>
            file.type.startsWith('image/') || file.type === 'application/pdf'
        );

        setFiles(prev => [...prev, ...validFiles]);

        // Reset file input to allow selecting the same file again
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };

    const removeFile = (index) => {
        setFiles(prev => prev.filter((_, i) => i !== index));
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.classList.add('dragover');
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        e.currentTarget.classList.remove('dragover');
    };

    const postProducts = async (postData) => {
        setLoading(true);
        try {
            const res = await postProduct(postData);
            const formattedData = res?.data?.data?.records.map(item => ({
                id: item?.product_id,
                productName: item?.product_name,
                projectCategory: item?.project_category?.proj_category_name,
                category: item?.category?.category_name,
                subCategory: item?.sub_category?.category_name,
                activityTemplate: item?.activity_template?.template_name,
            }));
            setData(formattedData);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const postUpdates = async () => {
        let postData = {
            length: 100
        }
        try {
            const res = await postProduct(postData);
            const formattedData = res?.data?.data?.records.map(item => ({
                id: item?.product_id,
                productName: item?.product_name,
                projectCategory: item?.project_category?.proj_category_name,
                category: item?.category?.category_name,
                subCategory: item?.sub_category?.category_name,
                activityTemplate: item?.activity_template?.template_name,
            }));
            setData(formattedData);

        } catch (error) {
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const getProjectCategoryMaps = async () => {
        try {
            const res = await getProjectCategoryMap();
            setProjectCategory(res.data.data);
        } catch (error) {
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    useEffect(() => {
        let postData = {
            length: 100
        }
        postProducts(postData);
    }, []);

    const addnew = async () => {
        formik.resetForm();
        setLoadings(true);
        getProjectCategoryMaps();
        setIsEdit(false);
        setFiles([]);
        let postData = {
            type: [
                "client_centric",
                "billing_entity_centric"
            ],
            org_type_code: ''
        }
        try {
            const res = await postCommonMaster(postData);
            setCommonMaster(res.data.data);
            setLoadings(false);
            setAddModal(true);
        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const columns = useMemo(
        () => [
            {
                Header: "Product Name",
                accessor: "productName",
            },
            {
                Header: "Sub-Category",
                accessor: "subCategory",
            },

            {
                Header: "Category",
                accessor: "category",
            },
            {
                Header: "Project Category",
                accessor: "projectCategory",
            },
            {
                Header: "Activity Template",
                accessor: "activityTemplate",
            },
            {
                Header: "Action",
                accessor: "action",
                disableSortBy: true,
            },
        ],
        []
    );

    const actions = ['edit', 'delete']
    const subActions = []

    const initialValues = {
        id: '',
        name: '',
        description: '',
        projCategoryId: '',
        categoryId: '',
        subCategoryId: '',
        activityTemplate: '',
        billingEntityCentricIds: [],
        clientCentricIds: [],
    }

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: '',
        onSubmit: async (values) => {
            setLoadings(true);

            const clientCentricIds = selectedClientCentricObjects.map(obj => ({
                id: obj.id,
                is_multiple: obj.is_multiple ? 1 : 0
            }));

            const billingEntityCentricIds = selectedBillingCentricObjects.map(obj => ({
                id: obj.id,
                is_multiple: obj.is_multiple ? 1 : 0
            }));

            let postData;

            if (isEdit) {
                postData = {
                    product_id: values.id,
                    product_name: values.name,
                    product_description: values.description,
                    proj_category_id: values.projCategoryId,
                    category_id: values.categoryId,
                    sub_category_id: values.subCategoryId,
                    activity_template_id: values.activityTemplate,
                    client_centric_ids: clientCentricIds,
                    billing_entity_centric_ids: billingEntityCentricIds
                };
            }
            else {
                postData = {
                    product_name: values.name,
                    product_description: values.description,
                    proj_category_id: values.projCategoryId,
                    category_id: values.categoryId,
                    sub_category_id: values.subCategoryId,
                    activity_template_id: values.activityTemplate,
                    client_centric_ids: clientCentricIds,
                    billing_entity_centric_ids: billingEntityCentricIds
                };
            }

            try {
                const res = await postProductSave(postData);
                toast.success(res.data.message);
                postUpdates();
                setLoadings(false);
                setAddModal(false);
                formik.resetForm();
            } catch (error) {
                setLoadings(false);
                toast.error(error.response?.data?.message || "Error submitting data");
            }
        },
    });
    const { values, handleChange, handleBlur, handleSubmit, setFieldValue, errors, touched } = formik;

    useEffect(() => {
        if (commonMaster?.client_centric) {
            setSelectedClientCentricObjects(prev => {
                const newIds = values.clientCentricIds || [];
                // Build objects from commonMaster for the selected IDs
                const newObjects = newIds.map(id => {
                    const item = commonMaster.client_centric.find(c => c.id === id);
                    if (!item) return null;
                    // Preserve is_multiple from previous state if it exists
                    const existing = prev.find(p => p.id === id);
                    return {
                        ...item,
                        is_multiple: existing ? existing.is_multiple : false
                    };
                }).filter(Boolean);
                return newObjects;
            });
        } else if (!values.clientCentricIds?.length) {
            // If no IDs selected, clear the table
            setSelectedClientCentricObjects([]);
        }
    }, [values.clientCentricIds, commonMaster?.client_centric]);

    useEffect(() => {
        if (commonMaster?.billing_entity_centric) {
            setSelectedBillingCentricObjects(prev => {
                const newIds = values.billingEntityCentricIds || [];
                const newObjects = newIds.map(id => {
                    const item = commonMaster.billing_entity_centric.find(b => b.id === id);
                    if (!item) return null;
                    const existing = prev.find(p => p.id === id);
                    return {
                        ...item,
                        is_multiple: existing ? existing.is_multiple : false
                    };
                }).filter(Boolean);
                return newObjects;
            });
        } else if (!values.billingEntityCentricIds?.length) {
            setSelectedBillingCentricObjects([]);
        }
    }, [values.billingEntityCentricIds, commonMaster?.billing_entity_centric]);

    const handleConfirm = () => {
        setAddModal(false);
        setIsEdit(false);
        setUploadModal(false);
        formik.resetForm();
    };

    const handleEdit = async (rowData) => {
        setLoadings(true);
        getProjectCategoryMaps();
        let postData = {
            type: [
                "client_centric",
                "billing_entity_centric"
            ],
            org_type_code: ''
        }
        try {
            const resp = await postCommonMaster(postData);
            setCommonMaster(resp.data.data);

            try {
                const res = await getProductDetails(rowData?.id);
                setFieldValue('id', res.data?.data?.product_id);
                setFieldValue('name', res.data?.data?.product_name);
                setFieldValue('description', res.data?.data?.product_description);
                setFieldValue('projCategoryId', res.data?.data?.project_category?.proj_category_id);
                setFieldValue('categoryId', res.data?.data?.category?.category_id);
                setFieldValue('subCategoryId', res.data?.data?.sub_category?.category_id);
                setFieldValue('activityTemplate', res.data?.data?.activity_template_id);

                const clientCentricIds = res.data?.data?.client_centric?.map(item => item.id) || [];
                const billingEntityCentricIds = res.data?.data?.billing_entity_centric?.map(item => item.id) || [];

                setFieldValue('clientCentricIds', clientCentricIds);
                setFieldValue('billingEntityCentricIds', billingEntityCentricIds);

                setSelectedClientCentricObjects([]);
                setSelectedBillingCentricObjects([]);

                setIsEdit(true);
                setLoadings(false);
                setAddModal(true);

                setSelectedClientCentricObjects(res.data?.data?.client_centric);
                setSelectedBillingCentricObjects(res.data?.data?.billing_entity_centric);

            } catch (error) {
                setLoadings(false);
                setIsEdit(false);
            }

        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const handleDelete = (rowData) => {
        setShow(true);
        setFieldValue('id', rowData?.id);
        setFieldValue('name', rowData?.name);
    };

    const handleDeleteCon = async () => {
        setLoadings(true);
        try {
            const res = await deleteProduct(values.id);
            toast.success(res.data.message);
            setLoadings(false);
            setShow(false);
            postUpdates();
            setFieldValue('id', '');
            setFieldValue('name', '');
        } catch (error) {
            setLoadings(false);
            setShow(false);
        }
    };

    const handleUploads = (rowData) => {
        setUploadModal(true);
    };

    useEffect(() => {
        if (values.projCategoryId) {
            const selectedProjCategory = projectCategory.find(cat => cat.proj_category_id == values.projCategoryId);

            if (selectedProjCategory && selectedProjCategory.category && selectedProjCategory.category.length > 0) {
                console.log(selectedProjCategory.category)
                setProductCategory(selectedProjCategory.category);
            } else {
                setProductCategory([]);
            }
        } else {
            setProductCategory([]);
        }
    }, [values.projCategoryId]);


    useEffect(() => {
        if (values.projCategoryId) {
            const selectedCategory = productCategory.find(cat => cat.category_id == values.categoryId);

            if (selectedCategory && selectedCategory.sub_category && selectedCategory.sub_category.length > 0) {
                console.log(selectedCategory.sub_category)
                setProductSubCategory(selectedCategory.sub_category);
            } else {
                setProductSubCategory([]);
            }
        } else {
            setProductSubCategory([]);
        }
    }, [values.projCategoryId, values.categoryId]);


    useEffect(() => {
        if (values.subCategoryId) {
            const selectedSubCategory = productSubCategory.find(cat => cat.category_id == values.subCategoryId);

            if (selectedSubCategory && selectedSubCategory.client_centric && selectedSubCategory.client_centric.length > 0) {
                const selectedValues = selectedSubCategory.client_centric.map(
                    item => item.id
                );
                setSelectedClientCentricObjects(selectedSubCategory.client_centric);
            } else {
                setFieldValue('clientCentricIds', []);
                setSelectedClientCentricObjects([]);
            }

            if (selectedSubCategory && selectedSubCategory.billing_entity_centric && selectedSubCategory.billing_entity_centric.length > 0) {
                const selectedValues = selectedSubCategory.billing_entity_centric.map(
                    item => item.id
                );
                setFieldValue('billingEntityCentricIds', selectedValues);
                setSelectedBillingCentricObjects(selectedSubCategory.billing_entity_centric);

            } else {
                setFieldValue('billingEntityCentricIds', []);
                setSelectedBillingCentricObjects([]);
            }



            if (selectedSubCategory && selectedSubCategory.activity_templates && selectedSubCategory.activity_templates.length > 0) {
                setActivityTemplates(selectedSubCategory.activity_templates);
            } else {
                setActivityTemplates([]);
            }
        } else {
            setActivityTemplates([]);
        }
    }, [values.projCategoryId, values.categoryId, values.subCategoryId]);

    return (
        <>
            <ToastContainer
                position="top-right"
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                style={{ zIndex: 9999999999, position: 'fixed' }}
            />

            {isLoading ? <Loader /> :
                <>
                    <PageTitle titles="Products" active="Products" items={['Home']} />
                    <Row>
                        <Col sm={12} className="col-12">
                            <Card>
                                <Card.Body className="example1-table">
                                    <div className='custompageHed'>
                                        <Row>
                                            <Col md={6}>
                                                <div className='pagetitle_hed'>
                                                    <h1>Products</h1>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className='w-100 d-flex justify-content-end'>
                                                    <button type='button' className='btn btn-primary' onClick={() => addnew()}>Add New</button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                    <Tables
                                        columns={columns}
                                        data={data}
                                        actions={actions}
                                        subActions={subActions}
                                        onEdit={handleEdit}
                                        onDelete={handleDelete}
                                    />
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </>
            }

            <Modals
                show={addModal}
                handleClose={() => { setAddModal(false); setIsEdit(false); }}
                title={isEdit ? "Edit Products" : 'Add New'}
                textColor='#000'
                size='xl'
                centered={true}
                backdrop={true}
                onConfirm={handleConfirm}
            >
                <form onSubmit={handleSubmit} autoComplete="off">
                    <Row>
                        <Col md={4}>
                            <div className="form-group">
                                <label className="form-label">Products Name</label>
                                <input
                                    type='text'
                                    id="name"
                                    name="name"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.name}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.name && touched.name && (
                                    <p className="errormsg">{errors.name}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="form-group">
                                <label className="form-label">Products Description</label>
                                <input
                                    type='text'
                                    id="description"
                                    name="description"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.description}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.description && touched.description && (
                                    <p className="errormsg">{errors.description}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="form-group">
                                <label className="form-label">Select Project Category</label>
                                <SelectFild
                                    Firstop='Select Product Category'
                                    selectName="projCategoryId"
                                    options={projectCategory}
                                    value={values.projCategoryId}
                                    onChange={(selectedOption) => setFieldValue("projCategoryId", selectedOption?.value || "")}
                                    onBlur={handleBlur}
                                />
                                {errors.projCategoryId && touched.projCategoryId && (
                                    <p className="errormsg">{errors.projCategoryId}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="form-group">
                                <label className="form-label">Select Product Category</label>
                                <SelectFild
                                    Firstop='Select Product Category'
                                    selectName="categoryId"
                                    options={productCategory}
                                    value={values.categoryId}
                                    onChange={(selectedOption) => setFieldValue("categoryId", selectedOption?.value || "")}
                                    onBlur={handleBlur}
                                />
                                {errors.categoryId && touched.categoryId && (
                                    <p className="errormsg">{errors.categoryId}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="form-group">
                                <label className="form-label">Select Product Sub-Category</label>
                                <SelectFild
                                    Firstop='Select Product Sub-Category'
                                    selectName="subCategoryId"
                                    options={productSubCategory}
                                    value={values.subCategoryId}
                                    onChange={(selectedOption) => setFieldValue("subCategoryId", selectedOption?.value || "")}
                                    onBlur={handleBlur}
                                />
                                {errors.subCategoryId && touched.subCategoryId && (
                                    <p className="errormsg">{errors.subCategoryId}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="form-group">
                                <label className="form-label">Select Activity Templates</label>
                                <SelectFild
                                    Firstop='Select Activity Templates'
                                    selectName="activityTemplate"
                                    options={activityTemplates}
                                    value={values.activityTemplate}
                                    onChange={(selectedOption) => setFieldValue("activityTemplate", selectedOption?.value || "")}
                                    onBlur={handleBlur}
                                />
                                {errors.activityTemplate && touched.activityTemplate && (
                                    <p className="errormsg">{errors.activityTemplate}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="form-group">
                                <label className="form-label">Select Client Centric Role</label>
                                <SelectFild
                                    Firstop='Select Client Centric Role'
                                    selectName='clientCentricIds'
                                    options={commonMaster?.client_centric}
                                    value={values.clientCentricIds}
                                    onChange={(selectedOptions) => {
                                        const selectedValues = selectedOptions ?
                                            Array.isArray(selectedOptions) ?
                                                selectedOptions.map(option => option.value) :
                                                selectedOptions.value :
                                            [];
                                        setFieldValue('clientCentricIds', selectedValues);
                                    }}
                                    onBlur={() => handleBlur('clientCentricIds')}
                                    isMulti={true}
                                />
                                {errors.clientCentricIds && touched.clientCentricIds && (
                                    <p className="errormsg">{errors.clientCentricIds}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="form-group">
                                <label className="form-label">Select Billing Entity Centric Role</label>
                                <SelectFild
                                    Firstop='Select Billing Entity Centric Role'
                                    selectName='billingEntityCentricIds'
                                    options={commonMaster?.billing_entity_centric}
                                    value={values.billingEntityCentricIds}
                                    onChange={(selectedOptions) => {
                                        const selectedValues = selectedOptions ?
                                            Array.isArray(selectedOptions) ?
                                                selectedOptions.map(option => option.value) :
                                                selectedOptions.value :
                                            [];
                                        setFieldValue('billingEntityCentricIds', selectedValues);
                                    }}
                                    onBlur={() => handleBlur('billingEntityCentricIds')}
                                    isMulti={true}
                                />
                                {errors.billingEntityCentricIds && touched.billingEntityCentricIds && (
                                    <p className="errormsg">{errors.billingEntityCentricIds}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={6}>
                            {selectedClientCentricObjects.length > 0 && (
                                <div className="fieldsets mainFS">
                                    <div className='fieldsetsboxs'>
                                        <h6>Selected Client Centric Role</h6>
                                    </div>
                                    <div className='formsBox'>
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th>Name</th>
                                                    <th style={{ width: 100 }}>Is Multiple</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {selectedClientCentricObjects.map(obj => (
                                                    <tr key={obj.id}>
                                                        <td>{obj.name}</td>
                                                        <td>
                                                            <div className="switchs" style={{ display: 'block', margin: '0 auto' }}>
                                                                <input
                                                                    type="checkbox"
                                                                    id={`swi_${obj.id}`}
                                                                    className="form-control"
                                                                    autoComplete="off"
                                                                    checked={obj.is_multiple || false}
                                                                    onChange={(e) => {
                                                                        setSelectedClientCentricObjects(prev =>
                                                                            prev.map(item =>
                                                                                item.id === obj.id
                                                                                    ? { ...item, is_multiple: e.target.checked }
                                                                                    : item
                                                                            )
                                                                        );
                                                                    }}
                                                                />
                                                                <span className="slider round"></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}
                        </Col>
                        <Col md={6}>
                            {selectedBillingCentricObjects.length > 0 && (
                                <div className="fieldsets mainFS">
                                    <div className='fieldsetsboxs'>
                                        <h6>Selected Billing Entity Centric Role</h6>
                                    </div>
                                    <div className='formsBox'>
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th>Name</th>
                                                    <th style={{ width: 100 }}>Is Multiple</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {selectedBillingCentricObjects.map(obj => (
                                                    <tr key={obj.id}>
                                                        <td>{obj.name}</td>
                                                        <td>
                                                            <div className="switchs" style={{ display: 'block', margin: '0 auto' }}>
                                                                <input
                                                                    type="checkbox"
                                                                    id={`swi_${obj.id}`}
                                                                    className="form-control"
                                                                    autoComplete="off"
                                                                    checked={obj.is_multiple || false}
                                                                    onChange={(e) => {
                                                                        setSelectedBillingCentricObjects(prev =>
                                                                            prev.map(item =>
                                                                                item.id === obj.id
                                                                                    ? { ...item, is_multiple: e.target.checked }
                                                                                    : item
                                                                            )
                                                                        );
                                                                        console.log(selectedBillingCentricObjects);
                                                                    }}
                                                                />
                                                                <span className="slider round"></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}
                        </Col>
                    </Row>
                    <div className='modalfooters'>
                        <div className='button-boxs grid'>
                            <button type='submit' className='btn btn-primary'>{isEdit ? "Update" : 'Save'}</button>
                            <button type='button' onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </form>
            </Modals>

            <Modals
                show={uploadModal}
                handleClose={() => setUploadModal(false)}
                title="Upload Sample Report"
                textColor='#000'
                size='xl'
                centered={true}
                backdrop={true}
                onConfirm={handleConfirm}
            >
                <form onSubmit={handleSubmit} autoComplete="off">
                    <Row>
                        <Col md={12}>
                            <div className='fieldsets'>
                                <div className='fieldsetsboxs'>
                                    <h6>Upload</h6>
                                </div>
                                <div className="formsBox upload-container">
                                    <div
                                        className="drop-zone"
                                        onDragOver={handleDragOver}
                                        onDragLeave={handleDragLeave}
                                        onDrop={handleDrop}
                                    >
                                        <p>Drag & Drop Here</p>
                                        <p>or</p>
                                        <button
                                            type="button"
                                            onClick={() => fileInputRef.current?.click()}
                                            className="select-button btn btn-primary"
                                        >
                                            Select Files
                                        </button>
                                        <input
                                            ref={fileInputRef}
                                            type="file"
                                            accept="image/*,.pdf"
                                            multiple
                                            onChange={handleFileSelect}
                                            style={{ display: 'none' }}
                                        />
                                    </div>

                                    {/* File list display */}
                                    {files.length > 0 && (
                                        <div className="file-list mt-3">
                                            <h6>Selected Files:</h6>
                                            <ul className="list-group">
                                                {files.map((file, index) => (
                                                    <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                                                        <span>
                                                            {file.name} ({file.type})
                                                        </span>
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-danger"
                                                            onClick={() => removeFile(index)}
                                                        >
                                                            Remove
                                                        </button>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}

                                    <div className="previewsimges">
                                        <div className='imageboxs'>
                                            <div className='imgs pdfs'>
                                                <div>
                                                    <div className='acbox'>
                                                        <button className='btn btn-removed'><FaTrashAlt /></button>
                                                    </div>
                                                    <div className="pdf-icon">
                                                        <FaFilePdf size={48} color="#e74c3c" />
                                                    </div>
                                                    <p>Gratuity.pdf</p>
                                                    <a href={pdfUrl} target="_blank" className='btn btn-primary' rel="noopener noreferrer">view Pdf</a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='imageboxs'>
                                            <div className='imgs pdfs'>
                                                <div>
                                                    <div className='acbox'>
                                                        <button className='btn btn-removed'><FaTrashAlt /></button>
                                                    </div>
                                                    <div className="pdf-icon">
                                                        <FaFilePdf size={48} color="#e74c3c" />
                                                    </div>
                                                    <p>Gratuity.pdf</p>
                                                    <a href={pdfUrl} target="_blank" className='btn btn-primary' rel="noopener noreferrer">view Pdf</a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='imageboxs'>
                                            <div className='imgs pdfs'>
                                                <div>
                                                    <div className='acbox'>
                                                        <button className='btn btn-removed'><FaTrashAlt /></button>
                                                    </div>
                                                    <div className="pdf-icon">
                                                        <FaFilePdf size={48} color="#e74c3c" />
                                                    </div>
                                                    <p>Gratuity.pdf</p>
                                                    <a href={pdfUrl} target="_blank" className='btn btn-primary' rel="noopener noreferrer">view Pdf</a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='imageboxs'>
                                            <div className='imgs pdfs'>
                                                <div>
                                                    <div className='acbox'>
                                                        <button className='btn btn-removed'><FaTrashAlt /></button>
                                                    </div>
                                                    <div className="pdf-icon">
                                                        <FaFilePdf size={48} color="#e74c3c" />
                                                    </div>
                                                    <p>Gratuity.pdf</p>
                                                    <a href={pdfUrl} target="_blank" className='btn btn-primary' rel="noopener noreferrer">view Pdf</a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='imageboxs'>
                                            <div className='imgs pdfs'>
                                                <div>
                                                    <div className='acbox'>
                                                        <button className='btn btn-removed'><FaTrashAlt /></button>
                                                    </div>
                                                    <div className="pdf-icon">
                                                        <FaFilePdf size={48} color="#e74c3c" />
                                                    </div>
                                                    <p>Gratuity.pdf</p>
                                                    <a href={pdfUrl} target="_blank" className='btn btn-primary' rel="noopener noreferrer">view Pdf</a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='imageboxs'>
                                            <div className='imgs pdfs'>
                                                <div>
                                                    <div className='acbox'>
                                                        <button className='btn btn-removed'><FaTrashAlt /></button>
                                                    </div>
                                                    <div className="pdf-icon">
                                                        <FaFilePdf size={48} color="#e74c3c" />
                                                    </div>
                                                    <p>Gratuity.pdf</p>
                                                    <a href={pdfUrl} target="_blank" className='btn btn-primary' rel="noopener noreferrer">view Pdf</a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='imageboxs'>
                                            <div className='imgs pdfs'>
                                                <div>
                                                    <div className='acbox'>
                                                        <button className='btn btn-removed'><FaTrashAlt /></button>
                                                    </div>
                                                    <div className="pdf-icon">
                                                        <FaFilePdf size={48} color="#e74c3c" />
                                                    </div>
                                                    <p>Gratuity.pdf</p>
                                                    <a href={pdfUrl} target="_blank" className='btn btn-primary' rel="noopener noreferrer">view Pdf</a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='imageboxs'>
                                            <div className='imgs pdfs'>
                                                <div>
                                                    <div className='acbox'>
                                                        <button className='btn btn-removed'><FaTrashAlt /></button>
                                                    </div>
                                                    <div className="pdf-icon">
                                                        <FaFilePdf size={48} color="#e74c3c" />
                                                    </div>
                                                    <p>Gratuity.pdf</p>
                                                    <a href={pdfUrl} target="_blank" className='btn btn-primary' rel="noopener noreferrer">view Pdf</a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='imageboxs'>
                                            <div className='imgs pdfs'>
                                                <div>
                                                    <div className='acbox'>
                                                        <button className='btn btn-removed'><FaTrashAlt /></button>
                                                    </div>
                                                    <div className="pdf-icon">
                                                        <FaFilePdf size={48} color="#e74c3c" />
                                                    </div>
                                                    <p>Gratuity.pdf</p>
                                                    <a href={pdfUrl} target="_blank" className='btn btn-primary' rel="noopener noreferrer">view Pdf</a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='imageboxs'>
                                            <div className='imgs pdfs'>
                                                <div>
                                                    <div className='acbox'>
                                                        <button className='btn btn-removed'><FaTrashAlt /></button>
                                                    </div>
                                                    <div className="pdf-icon">
                                                        <FaFilePdf size={48} color="#e74c3c" />
                                                    </div>
                                                    <p>Gratuity.pdf</p>
                                                    <a href={pdfUrl} target="_blank" className='btn btn-primary' rel="noopener noreferrer">view Pdf</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <div className='modalfooters'>
                        <div className='button-boxs grid'>
                            <button type='submit' className='btn btn-primary'>save</button>
                            <button type='button' onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </form>
            </Modals>

            {show ? (<>
                <Alert variant="danger" onClose={() => setShow(false)} dismissible>
                    <Alert.Heading>Are you sure want to Delete <span>{values.name}</span> Products ?</Alert.Heading>
                    <hr />
                    <div className='button-boxs grid'>
                        <div>
                            <button onClick={() => handleDeleteCon()} className='btn btn-primary'>OK</button>
                        </div>
                        <div>
                            <button onClick={() => setShow(false)} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </Alert>
                <div className='overly'></div>
            </>) : null}
            {isLoadings && <Loader />}
        </>
    )
}

export default Products